import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const StyledDiv = styled.div({
  height: '100%',
  display: 'flex',
  [media('xs')]: {
    flexDirection: 'column-reverse',
    justifyContent: 'flex-end'
  },
  [media('lg')]: {
    flexDirection: 'column'
  }
});

export default StyledDiv;
